import { gql } from "@apollo/client"

export const getApiKey = gql`
  query MyQuery($address: String!) {
    getNonce(address: $address) {
      NONCE
    }
  }
`

export const loginGql = gql`
  query MyQuery($address: String!, $sign: String!) {
    login(address: $address, sign: $sign) {
      token
      status
    }
  }
`

export const getFavoriteList = gql`
  query MyQuery {
    getFavorite {
      items {
        TIMESTAMP
        DOMAIN
      }
    }
  }
`

export const addFavoriteGql = gql`
  mutation MyMutation($domainName: String!) {
    addFavorite(input: { DOMAIN: $domainName }) {
      DOMAIN
      TIMESTAMP
    }
  }
`

export const removeFavoriteGql = gql`
  mutation MyMutation($domainName: String!) {
    removeFavorite(input: { DOMAIN: $domainName }) {
      DOMAIN
      TIMESTAMP
    }
  }
`
